<template lang="pug">
#bloco-inserir-dados-contrato-originacao-manual
    h1 Inserir dados do contrato de originação manualmente
    el-card
        .box-card-inserir-dados-manual
            .box-card-inserir-dados-manual__conteudo
                .box-card-inserir-dados-manual__conteudo__bloco
                    span Pesquise pelo imóvel e insira o volume à lista.

                .box-card-inserir-dados-manual__conteudo__bloco
                    .box-card-inserir-dados-manual__conteudo__bloco_pesquisa
                        .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-territorio
                            span Pesquise por território
                            el-select(
                                v-model='territorioSelecionado',
                                filterable,
                                remote,
                                reserve-keyword,
                                placeholder='Busque por CAR ou Documento',
                                remote-show-suffix,
                                :remote-method='fetchTerritorios'
                            )
                                el-option(
                                    v-for='territorio in territorios',
                                    :key='territorio.nome',
                                    :label='territorio.nome',
                                    :value='territorio.id'
                                )

                        .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-volume
                            span Volume (t)
                            el-input(
                                placeholder='Inserir volume',
                                type='number',
                                v-model='volumeTerritorio'
                            )

                .box-card-inserir-dados-manual__conteudo__bloco
                    .box-card-inserir-dados-manual__conteudo__bloco__buttons
                        BaseButton(
                            icon='el-icon-circle-plus-outline',
                            @click=''
                        ) Cadastrar território

                        BaseButton(
                            type='primary',
                            icon='el-icon-plus',
                            @click='adicionarTerritorioManual'
                        ) Adicionar à lista
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'BlocoInserirDadosManual',
    components: {
        BaseButton
    },
    emits: ['atualizar-lista'],
    data() {
        return {
            pesquisaTerritorio: '',
            volumeTerritorio: '',
            territorios: [],
            nome: [],
            territorioSelecionado: '',
            territorioContrato: [],
            numeroContrato: this.$route.params.numeroContrato
        };
    },

    methods: {
        async fetchTerritorios(filtro) {
            try {
                const { data } = await ContratoOriginacaoService.findAll(filtro);
                this.territorios = data.content;
            } catch (error) {
            }
        },

        adicionarTerritorioManual() {
            try {
                const contrato = {
                    idTerritorio: this.territorioSelecionado,
                    numeroContrato: this.numeroContrato,
                    volume: this.volumeTerritorio
                };
                ContratoOriginacaoService.inserirDadosContrato(contrato)
                .then(() => this.$emit('atualizar-lista'))
                .catch(erro => this.$notify.error(erro.response.data.message));
            } catch (error) {
                this.$notify.error({
                    message:
                        'Erro na requisição de adicionar território.'
                });
            }
        }
    }
};
</script>

<style lang="scss">
#bloco-inserir-dados-contrato-originacao-manual {
    width: 100%;

    h1 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .el-card.is-always-shadow {
        min-height: 308px;
    }

    el-card {
        margin-top: 10px;
        display: flex;
    }

    .box-card-inserir-dados-manual__conteudo {
        display: flex;
        flex-direction: column;
        align-content: space-around;
        gap: 35px;

        .box-card-inserir-dados-manual__conteudo__bloco {
            margin-bottom: 15px;
            display: flex;

            .box-card-inserir-dados-manual__conteudo__bloco__buttons {
                display: flex;
                justify-content: space-between;
                gap: 15px;
                width: 100%;
            }
        }
    }

    .box-card-inserir-dados-manual__conteudo__bloco_pesquisa {
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        gap: 15px;
        width: 100%;

        .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-territorio {
            display: flex;
            flex-direction: column;

            input {
                -webkit-appearance: none;
                background-color: #fff;
                background-image: none;
                border-radius: 4px;
                border: 1px solid #dcdfe6;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                color: #606266;
                display: inline-block;
                font-size: inherit;
                height: 40px;
                width: 368px;
                line-height: 40px;
                outline: none;
                padding: 0 15px;
                -webkit-transition: border-color 0.2s
                    cubic-bezier(0.645, 0.045, 0.355, 1);
                transition: border-color 0.2s
                    cubic-bezier(0.645, 0.045, 0.355, 1);
                touch-action: manipulation;
            }
        }
    }
}
</style>
